import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton } from "material-ui"
import strings from "../../../localization/strings"
import EditPunchForm from "../EditPunchForm"
import { IEquipmentDocument, IJobDocument, IJobPhase, IPosition, IUIUser, IPunchBundle, IPunchShortDocument } from "../../../models"
import GlobalPunchEditReviewDialog from "./GlobalPunchEditReviewDialog"
import { grey800 } from "material-ui/styles/colors"
import * as punchHelper from "../../../helpers/punchHelper"
interface IProps {
    globalPunchEmployees: IUIUser[]
    selectedPunchBundles: IPunchBundle[]
    handleClose(): void
    handleEditGlobalPunches(punchBundles: IPunchBundle[]): void
}
interface IState {
    loadingPositions: boolean
    openReviewDialog: boolean
    hierarchyLevelId?: string
    positionId?: string
    payClassId?: string
    equipment?: IEquipmentDocument
    payTypeId?: string
    job?: IJobDocument
    phase?: IJobPhase
    punchPosition?: IPosition
}

export default class GlobalPunchEditDialog extends React.Component<IProps, IState> {
    private EditPunchForm
    private commonGlobalPunchData: IPunchShortDocument
    constructor(props: IProps) {
        super(props)
        this.commonGlobalPunchData = punchHelper.getCommonGlobalPunchData(props.selectedPunchBundles)
        this.state = {
            loadingPositions: false,
            openReviewDialog: false
        }
        autobind(this)
    }

    reviewChanges() {
        const { hierarchyLevelId, errorHierarchyId, positionId, errorPunchPosition, payClassId, equipment, payTypeId, errorPayTypeId, job, phase, punchPosition } = this.EditPunchForm.state
        if (errorHierarchyId || errorPayTypeId || errorPunchPosition) return
        this.setState({
            openReviewDialog: true,
            hierarchyLevelId,
            positionId,
            payClassId,
            equipment,
            payTypeId,
            job,
            phase,
            punchPosition
        })
    }

    render() {
        return (
            <Dialog
                open
                title={strings.formatString(strings.Edit_x_Punches, this.props.selectedPunchBundles.length)}
                actions={[
                    <FlatButton key="Cancel" label={strings.Cancel} secondary onClick={this.props.handleClose} />,
                    <FlatButton key="Punch" label={strings.Review_Changes} disabled={this.state.loadingPositions} primary onClick={this.reviewChanges} />
                ]}
            >
                <span style={{ paddingLeft: 10, color: grey800 }}>
                    {strings.Note_If_field_is_left_blank_that_property_will_not_be_updated}
                </span>
                <EditPunchForm
                    isGlobalPunch
                    globalPunchEmployees={this.props.globalPunchEmployees.filter(i => this.props.selectedPunchBundles.find(e => e.Punch.UserId === i.Id))}
                    ref={item => this.EditPunchForm = item}
                    handleLoadingPositions={loadingPositions => this.setState({ loadingPositions })}
                    commonGlobalPunchData={this.commonGlobalPunchData}
                />
                {this.state.openReviewDialog &&
                    <GlobalPunchEditReviewDialog
                        originalCommonGlobalPunchData={this.commonGlobalPunchData}
                        selectedPunchBundles={this.props.selectedPunchBundles}
                        hierarchyLevelId={this.state.hierarchyLevelId}
                        positionId={this.state.positionId}
                        payClassId={this.state.payClassId}
                        equipment={this.state.equipment}
                        payTypeId={this.state.payTypeId}
                        job={this.state.job}
                        phase={this.state.phase}
                        punchPosition={this.state.punchPosition}
                        handleClose={() => this.setState({ openReviewDialog: false })}
                        handleEditGlobalPunches={punchBundles =>
                            this.setState({ openReviewDialog: false }, () =>
                                this.props.handleEditGlobalPunches(punchBundles)
                            )
                        }
                    />
                }
            </Dialog>
        )
    }
}
